import {
  _COALESCED_STYLE_SCHEDULER,
  _CoalescedStyleScheduler, CDK_TABLE,
  CDK_TABLE_TEMPLATE,
  CdkTable,
  STICKY_POSITIONING_LISTENER
} from '@angular/cdk/table';
import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { _DisposeViewRepeaterStrategy, _VIEW_REPEATER_STRATEGY } from '@angular/cdk/collections';

@Component({
  selector: 'mui-table, table[mui-table]',
  exportAs: 'muiTable',
  template: CDK_TABLE_TEMPLATE,
  // eslint-disable-next-line @angular-eslint/no-host-metadata-property
  host: {
    class: 'mui-table',
  },
  providers: [
    // See https://github.com/angular/components/blob/master/src/material/table/table.ts
    {provide: CdkTable, useExisting: MuiTable},
    {provide: CDK_TABLE, useExisting: MuiTable},
    {provide: _VIEW_REPEATER_STRATEGY, useClass: _DisposeViewRepeaterStrategy},
    {provide: _COALESCED_STYLE_SCHEDULER, useClass: _CoalescedStyleScheduler},
    // Prevent nested tables from seeing this table's StickyPositioningListener.
    {provide: STICKY_POSITIONING_LISTENER, useValue: null},
  ],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Default,
})

export class MuiTable<T> extends CdkTable<T> {
  protected stickyCssClass = 'mui-table-sticky';
}
